import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add token to requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

const adminService = {
    // Get pending products for verification
    getPendingProducts: async (page = 1, limit = 20) => {
        const response = await api.get(`/admin/pending-products?page=${page}&limit=${limit}`);
        return response.data;
    },

    // Verify (approve/reject) a product
    verifyProduct: async (productId, action, rejectionReason = '') => {
        const response = await api.put(`/admin/products/${productId}/verify`, {
            action,
            rejectionReason
        });
        return response.data;
    },

    // Get all seller products (for admin overview)
    getSellerProducts: async (status = '', page = 1, limit = 20) => {
        let url = `/admin/seller-products?page=${page}&limit=${limit}`;
        if (status) {
            url += `&status=${status}`;
        }
        const response = await api.get(url);
        return response.data;
    },

    // Get dashboard stats
    getStats: async () => {
        const response = await api.get('/admin/stats');
        return response.data;
    },

    // Get all sellers with stats
    getSellers: async () => {
        const response = await api.get('/admin/sellers?limit=1000');
        return response.data;
    },

    // Update seller status (backward compatibility)
    updateSellerStatus: async (sellerId, status) => {
        const response = await api.put(`/admin/sellers/${sellerId}/status`, { status });
        return response.data;
    },

    // Update seller information (status, plan, etc.)
    updateSeller: async (sellerId, data) => {
        const response = await api.put(`/admin/sellers/${sellerId}`, data);
        return response.data;
    },

    // Get detailed seller info with products and orders
    getSellerDetails: async (sellerId) => {
        const response = await api.get(`/admin/sellers/${sellerId}?include=profile,stats,products,orders,business`);
        return response.data;
    },
    // Promotion Requests
    getPromotionRequests: async (status = '') => {
        const params = status ? `?status=${status}` : '';
        const response = await api.get(`/promotion-requests${params}`);
        return response.data;
    },
    approvePromotionRequest: async (id) => {
        const response = await api.post(`/promotion-requests/${id}/approve`);
        return response.data;
    },
    rejectPromotionRequest: async (id, notes = '') => {
        const response = await api.post(`/promotion-requests/${id}/reject`, { notes });
        return response.data;
    },
    // Hero Product Requests
    getHeroProductRequests: async (status = '') => {
        const params = status ? `?status=${status}` : '';
        const response = await api.get(`/hero-products${params}`);
        return response.data;
    },
    approveHeroProductRequest: async (id) => {
        const response = await api.post(`/hero-products/${id}/approve`);
        return response.data;
    },
    rejectHeroProductRequest: async (id, notes = '') => {
        const response = await api.post(`/hero-products/${id}/reject`, { notes });
        return response.data;
    },

    // Get all orders for a specific seller
    getSellerOrders: async (sellerId) => {
        const response = await api.get(`/orders/seller/${sellerId}/orders`);
        return response.data;
    },

    // Toggle or set approvedPaid status for a seller
    setApprovedPaid: async (sellerId, approvedPaid) => {
        const payload = approvedPaid !== undefined ? { approvedPaid } : {};
        const response = await api.put(`/admin/sellers/${sellerId}/approved-paid`, payload);
        return response.data;
    },
};

export default adminService;
